import RoundedCard from './RoundedCard';

interface SkeletonCardProps {
  count: number;
}

const SkeletonCard = ({ count }: SkeletonCardProps) => {
  return (
    <RoundedCard>
      <div className="px-[20px] pb-[12px]">
        {/* 상단 영역 */}
        <div className="flex pt-[20px] pb-[6px] gap-[12px] items-center">
          {/* 이미지 스켈레톤 */}
          <div className="animate-pulse bg-gray-100 dark:bg-gray-800 w-[56px] h-[56px] rounded-full shrink-0" />

          {/* 텍스트 영역 */}
          <div className="flex flex-col gap-[8px] items-start w-full">
            <div className="animate-pulse bg-gray-100 dark:bg-gray-800 w-[56px] h-[16px] rounded" />
            <div className="animate-pulse bg-gray-100 dark:bg-gray-800 w-[120px] h-[18px] rounded" />
          </div>
        </div>

        {/* 메뉴 리스트 스켈레톤 */}
        <div className="mt-[12px]">
          {Array.from({ length: count }).map((_, i) => (
            <div
              // biome-ignore lint/suspicious/noArrayIndexKey: skeleton
              key={i}
              className={`py-[14px] pl-[4px] ${
                i !== count - 1
                  ? 'shadow-[inset_0_-1px_0_0_rgba(0,0,0,0.04)] dark:shadow-[inset_0_-1px_0_0_rgba(255,255,255,0.06)]'
                  : ''
              }`}
            >
              <div className="flex items-center justify-between w-full">
                <div className="animate-pulse bg-gray-100 dark:bg-gray-800 w-[140px] h-[14px] rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </RoundedCard>
  );
};

export default SkeletonCard;
